var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('v-card', [_c('v-card-title', {
    staticClass: "justify-space-between text-h5 font-weight-medium"
  }, [_c('span', [_vm._v(" " + _vm._s(_vm.submission.problemPreview.title) + " ")]), _c('v-btn', {
    attrs: {
      "icon": ""
    },
    on: {
      "click": _vm.closeSubModal
    }
  }, [_c('v-icon', [_vm._v(" " + _vm._s(_vm.mdiClose) + " ")])], 1)], 1), _c('v-card-text', [_c('pre', [_vm._v(_vm._s(_vm.submission.submission.code) + "\n      ")])])], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }